import { withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { CompToUpdateData, ISamePageAnchorPropsResolver, ScrollToAnchorHandlers } from '../types'
import { name, SamePageAnchorPropsResolverSymbol } from '../symbols'
import { IPropsStore, Props, DSViewModeAPISymbol, IViewMode } from '@wix/thunderbolt-symbols'

export const SamePageAnchorHrefHandlersImplementor = withDependencies(
	[SamePageAnchorPropsResolverSymbol, Props, DSViewModeAPISymbol],
	(
		{ getPropsOverrides }: ISamePageAnchorPropsResolver,
		propsStore: IPropsStore,
		{ registerToNextSwitchViewModeDone, isDuringViewModeSwitch }: IViewMode
	): IModelUpdatesHandlersImplementor<ScrollToAnchorHandlers> => {
		const updateComponentProps = (compToUpdateData: CompToUpdateData) => {
			if (propsStore.get(compToUpdateData.compId)) {
				const updatedProps = getPropsOverrides(compToUpdateData)
				propsStore.update(updatedProps)
			}
		}

		return {
			featureName: name,
			handlers: {
				onComponentUpdate: (compToUpdateData) => {
					if (isDuringViewModeSwitch()) {
						registerToNextSwitchViewModeDone(() => updateComponentProps(compToUpdateData))
					} else {
						updateComponentProps(compToUpdateData)
					}
				},
			},
		}
	}
)
